import React, { useState } from 'react'

import { StaticImage } from 'gatsby-plugin-image'

import PlayIcon from 'svgs/play.svg'

export default function MeetTheTeam() {
  const [show, setShow] = useState(true)
  return (
    <div className="bg-black py-4 md:pt-20 md:pb-5">
      <div className="w-11/12 mx-auto container max-w-[1100px] text-center">
        <h3 className="text-2xl md:text-[38px] md:mb-6">MEET THE TEAM</h3>
        <div
          className="border-4 border-[#FFC700] rounded shadow-md max-w-[1000px] mx-auto my-3 relative"
          onClick={() => setShow(false)}
        >
          <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
            <iframe
              src="https://player.vimeo.com/video/814619774?h=1cf7d989df&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowfullscreen
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
              }}
              title="Dorothy Dandridge Interviews 6 (1).mp4"
            />
          </div>
          <script src="https://player.vimeo.com/api/player.js" />
          {/* <ReactPlayer
            url="https://player.vimeo.com/video/814619774?h=1cf7d989df&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            width="100%"
            height="auto"
            className="rounded [&>iframe]:rounded aspect-video"
            controls
          /> */}
          <div
            className={`absolute inset-0 w-full h-full ${
              !show ? 'opacity-0 invisible' : 'opacity-1 visible'
            }`}
          >
            <StaticImage
              src="../../../images/hero/hero.png"
              alt=""
              className="w-full h-full"
            />
            <div className="absolute inset-0 [&>svg]:fill-[#FFC700] [&>svg]:w-[40px] [&>svg]:h-[40px] shadow w-full h-full flex items-center justify-center md:[&>svg]:w-[60px] md:[&>svg]:h-[60px]">
              <PlayIcon />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
